import { Inject, Injectable, Optional } from '@angular/core';
import * as _ from 'underscore';

@Injectable()
export class PageService {

  checkArrayForPage(pageArray, pageTofind): any {
    return _.findIndex(pageArray, (page) => {

      if (_.isObject(page) && _.isEqual(_.keys(page)[0], pageTofind)) {
        return true;
      }

      if (_.isArray(page)) {
        const containsPage = _.find(_.flatten(page), (object) => {
          if (_.keys(object)[0] === pageTofind) {
            return true;
          }
        });

        if (!_.isUndefined(containsPage)) {
          return true;
        }
      }
    });
  }

  getNextPage(currentPage, workflow): any {
    const pagename = this.getNextPageName(currentPage, workflow);

    if (pagename === 'exitarray') {
      return workflow[0];
    }

    return pagename;
  }

  getNextPageName(currentPage, workflow) {
    const currentPageIndex = this.checkArrayForPage(workflow, currentPage);

    if (currentPageIndex === -1) {
      return 'exitarray';
    }

    const nextPageIndex = currentPageIndex + 1;

    if (_.isArray(workflow[currentPageIndex])) {
      const currentPageFlow = this.getNextPageName(currentPage, workflow[currentPageIndex]);
      if (currentPageFlow === 'exitarray') {

        if (_.isArray(workflow[nextPageIndex])) {
          return 'exitarray';
        }

        if (_.isObject(workflow[nextPageIndex])) {
          return workflow[nextPageIndex];
        }
      }
      return currentPageFlow;
    }

    if (_.isObject(workflow[nextPageIndex])) {
      return workflow[nextPageIndex];
    }

    if (_.isUndefined(workflow[nextPageIndex])) {
      return 'exitarray';
    }
  }

  getPageByName(pageName: string, workflow: Array<any>) {
    return _.find(_.flatten(workflow), (page) => {
      if (_.isEqual(_.values(page)[0], pageName)) {
        return true;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./app/widgets/templateDrivenWidget/page.service.ts